module.exports = __webpack_public_path__ + "a8c2cc275fbdafb2e1f1576ff660f4c9.jpg";